import {
    GET_FOLDER_PERMISSION,
    GET_FOLDER_PERMISSION_SUCCESS,
    GET_FOLDER_PERMISSION_FAILED
} from './constants';

type Action = { type: string, payload: {} | string };

export const getFolderPermission = (): Action => ({
    type: GET_FOLDER_PERMISSION,
    payload: {},
});

export const getFolderPermissionSuccess = (entities: Array): Action => ({
    type: GET_FOLDER_PERMISSION_SUCCESS,
    payload: entities,
});

export const getFolderPermissionFailed = (error: string): Action => ({
    type: GET_FOLDER_PERMISSION_FAILED,
    payload: error,
});
